import * as React from "react";

const SvgInterference = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
  <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
fill="currentColor" stroke="none">
<path d="M2457 4383 c-4 -3 -7 -775 -7 -1715 l0 -1708 190 0 190 0 0 1715 0
1715 -183 0 c-101 0 -187 -3 -190 -7z"/>
<path d="M1211 4096 l-134 -134 55 -59 c281 -301 463 -673 533 -1093 23 -136
30 -382 16 -525 -46 -453 -227 -863 -529 -1203 l-75 -84 129 -129 c71 -71 134
-129 141 -129 28 0 243 265 342 422 341 541 460 1200 330 1831 -34 166 -122
417 -204 583 -109 222 -281 469 -422 606 l-48 48 -134 -134z"/>
<path d="M673 3558 l-131 -133 60 -70 c155 -180 254 -383 305 -625 24 -115 24
-370 0 -492 -48 -240 -160 -468 -313 -636 l-57 -64 134 -134 134 -135 63 68
c130 140 247 330 321 519 206 523 141 1125 -171 1581 -61 89 -195 253 -207
253 -4 0 -65 -60 -138 -132z"/>
<path d="M132 3017 l-132 -132 24 -25 c39 -39 95 -139 116 -206 56 -183 17
-386 -102 -530 l-39 -48 133 -133 132 -133 34 33 c55 52 147 199 181 286 52
136 65 202 65 351 0 168 -23 272 -94 416 -44 91 -158 254 -178 254 -4 0 -67
-60 -140 -133z"/>
<path d="M3220 2480 l0 -380 188 2 187 3 3 378 2 377 -190 0 -190 0 0 -380z"/>
<path d="M4740 2480 l0 -380 190 0 190 0 0 380 0 380 -190 0 -190 0 0 -380z"/>
<path d="M3980 2290 l0 -190 190 0 190 0 0 190 0 190 -190 0 -190 0 0 -190z"/>
</g>


  </svg>
);

export default SvgInterference;
